/* eslint-disable complexity */
import React from 'react';

import EditorInfoIcon from '@atlaskit/icon/glyph/editor/info';
import EditorSuccessIcon from '@atlaskit/icon/glyph/editor/success';
import LockFilledIcon from '@atlaskit/icon/glyph/lock-filled';
import UnlockIcon from '@atlaskit/icon/glyph/unlock';
import Tooltip from '@atlaskit/tooltip';

import { Button } from '@qality/common-components/src/atoms/Button';
import { Text } from '@qality/common-components/src/atoms/Text';
import {
  FEATURE_FLAG,
  UPGRADE_TO_QALITY_PLUS_TOOLTIP_MESSAGE,
} from '@qality/common-config';

import {
  ButtonOverlay,
  ButtonWrapper,
  Container,
} from './CloseReopenCycle.styled';

interface CloseReopenCycleViewProps {
  isClosed: boolean;
  updateTestCycleState: () => void;
  canEdit: boolean;
}

export const CloseReopenCycleView: React.FC<CloseReopenCycleViewProps> = ({
  isClosed,
  updateTestCycleState,
  canEdit,
}: CloseReopenCycleViewProps) => {
  const isDisabled = !canEdit || !FEATURE_FLAG.isPremium;

  return (
    <Container>
      {isClosed ? (
        <>
          <EditorSuccessIcon label='opened' />
          <Text>This Test Cycle is closed</Text>
          <ButtonWrapper>
            {!FEATURE_FLAG.isPremium && (
              <Tooltip content={UPGRADE_TO_QALITY_PLUS_TOOLTIP_MESSAGE}>
                <ButtonOverlay />
              </Tooltip>
            )}
            <Button
              iconBefore={<UnlockIcon label='open' size='small' />}
              onClick={updateTestCycleState}
              isDisabled={isDisabled}
              marginSize='small'
              ml
            >
              Reopen
            </Button>
          </ButtonWrapper>
        </>
      ) : (
        <>
          <EditorInfoIcon label='closed' />
          <Text>This Test Cycle is open</Text>
          <ButtonWrapper>
            {!FEATURE_FLAG.isPremium && (
              <Tooltip content={UPGRADE_TO_QALITY_PLUS_TOOLTIP_MESSAGE}>
                <ButtonOverlay />
              </Tooltip>
            )}
            <Button
              iconBefore={<LockFilledIcon label='close' size='small' />}
              onClick={updateTestCycleState}
              isDisabled={isDisabled}
              marginSize='small'
              ml
            >
              Close
            </Button>
          </ButtonWrapper>
        </>
      )}
    </Container>
  );
};
